<!--
  @copyright 汽车商贸管理平台 V1.0
  @year 2026
  @description InventoryRecords
-->
<template>
  <div class="records">
    <van-nav-bar title="盘点记录" left-arrow @click-left="$router.back()" />

    <div class="record-list">
      <div class="record-card" v-for="item in records" :key="item.no">
        <div class="record-header">
          <span class="record-vid">{{ item.vid }}</span>
          <van-tag :type="item.status === '正常' ? 'success' : 'warning'">
            {{ item.status || '未知' }}
          </van-tag>
        </div>
        <div class="record-body">
          <div class="record-info">
            <span class="label">车辆：</span>
            <span>{{ item.vehicleBand }} {{ item.vehicleModel }}</span>
          </div>
          <div class="record-info">
            <span class="label">公司：</span>
            <span>{{ item.ownerCompany || '未知' }}</span>
          </div>
          <div class="record-info">
            <span class="label">盘点人：</span>
            <span>{{ item.checker }}</span>
          </div>
          <div class="record-info">
            <span class="label">盘点时间：</span>
            <span>{{ item.checkTime }}</span>
          </div>
          <div class="record-info" v-if="item.locationName">
            <span class="label">位置：</span>
            <span>{{ item.locationName }}</span>
          </div>
          <div class="record-info" v-if="item.remark">
            <span class="label">备注：</span>
            <span>{{ item.remark }}</span>
          </div>
        </div>
        <div class="record-footer">
          <div class="footer-left">
            <div class="media-link video-link" v-if="item.videoPath" @click="playVideo(item.videoPath)">
              查看视频
            </div>
            <div class="media-link photo-link" v-if="item.photoCount > 0" @click="viewPhotos(item)">
              查看照片 ({{ item.photoCount }})
            </div>
          </div>
          <div class="delete-link" @click="confirmDelete(item)">
            删除
          </div>
        </div>
      </div>

      <div v-if="!loading && records.length === 0" class="empty-tip">
        暂无盘点记录
      </div>
    </div>

    <!-- 视频预览弹窗 -->
    <van-overlay :show="showVideo" @click="showVideo = false">
      <div class="media-container">
        <video
          ref="videoPlayer"
          :src="mediaUrl"
          controls
          autoplay
          class="video-player"
        ></video>
        <div class="media-close" @click="showVideo = false">关闭</div>
      </div>
    </van-overlay>

    <!-- 照片预览弹窗 -->
    <van-overlay :show="showPhotos" @click="showPhotos = false">
      <div class="media-container">
        <div class="photo-viewer" v-if="photoList.length > 0">
          <img :src="photoList[currentPhotoIndex]" class="photo-display" @click.stop />
          <div class="photo-nav">
            <div class="nav-btn" @click.stop="prevPhoto" v-if="currentPhotoIndex > 0">上一张</div>
            <span class="photo-index">{{ currentPhotoIndex + 1 }} / {{ photoList.length }}</span>
            <div class="nav-btn" @click.stop="nextPhoto" v-if="currentPhotoIndex < photoList.length - 1">下一张</div>
          </div>
        </div>
        <div class="media-close" @click="showPhotos = false">关闭</div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {getCheckedRecords,getMediaList,deleteCheckRecord } from "../api/index";
import { Toast } from "vant";

export default {
  name: "InventoryRecords",
  data() {
    return {
      records: [],
      loading: false,
      showVideo: false,
      mediaUrl: "",
      showPhotos: false,
      photoList: [],
      currentPhotoIndex: 0,
    };
  },
  created() {
    this.loadRecords();
  },
  methods: {
    async loadRecords() {
      this.loading = true;
      try {
        const res = await getCheckedRecords();  // http.get("/api/Inventory/GetCheckedRecords");
        if (res.code === 0) {
          this.records = res.data || [];
        }
      } catch (error) {
        console.error("加载记录失败:", error);
      } finally {
        this.loading = false;
      }
    },
    getMediaApiUrl(filePath) {
      // 如果已经是 /api/ 开头，直接使用
      if (filePath.startsWith("/api/")) {
        return window.location.origin + filePath;
      }
      // 如果是本地路径（如 D:\网站\...），提取日期、类型、文件名，构造API路由
      // 匹配 inventory/{date}/(video|photo)/{fileName}
      const match = filePath.match(/inventory[/\\](\d{4}-\d{2}-\d{2})[/\\](video|photo)[/\\](.+)/);
      if (match) {
        const [, date, type, fileName] = match;
        const typePath = type.charAt(0).toUpperCase() + type.slice(1); // Video/Photo
        return window.location.origin + `/api/Inventory/${typePath}/${date}/${fileName}`;
      }
      // 兜底：原样拼接
      return window.location.origin + filePath;
    },
    async playVideo(path) {
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      const url = this.getMediaApiUrl(path);
      console.log(url)
      try {
        const response = await fetch(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.ok) {
          const blob = await response.blob();
          this.mediaUrl = URL.createObjectURL(blob);
          this.showVideo = true;
        } else {
          Toast("视频加载失败");
        }
      } catch (error) {
        Toast("视频请求失败");
      }
    },
    async viewPhotos(item) {
      try {
        const res = await getMediaList(item.no, 'photo'); //http.get(`/api/Inventory/GetMediaList/${item.no}?fileType=photo`);
        if (res.code === 0 && res.data && res.data.length > 0) {
          const token = localStorage.getItem("token") || sessionStorage.getItem("token");
          const urls = [];
          for (const photo of res.data) {
            const url = this.getMediaApiUrl(photo.filePath);
            console.log(url);
            try {
              const response = await fetch(url, {
                headers: { Authorization: `Bearer ${token}` },
              });
              if (response.ok) {
                const blob = await response.blob();
                urls.push(URL.createObjectURL(blob));
              }
            } catch (e) {
              console.error("照片加载失败:", e);
            }
          }
          if (urls.length > 0) {
            this.photoList = urls;
            this.currentPhotoIndex = 0;
            this.showPhotos = true;
          } else {
            console.log(1)
            Toast("照片加载失败");
          }
        } else {
          Toast("暂无照片");
        }
      } catch (error) {
        Toast("加载照片失败");
      }
    },
    prevPhoto() {
      if (this.currentPhotoIndex > 0) {
        this.currentPhotoIndex--;
      }
    },
    nextPhoto() {
      if (this.currentPhotoIndex < this.photoList.length - 1) {
        this.currentPhotoIndex++;
      }
    },
    confirmDelete(item) {
      this.$dialog.confirm({
        title: "确认删除",
        message: "删除后将回到盘点任务列表，确定要删除吗？",
      }).then(() => {
        this.deleteRecord(item.no);
      }).catch(() => {});
    },
    async deleteRecord(recordId) {
      try {
        const formData = new FormData();
        formData.append("recordId", recordId);
        //console.log(formData.get("recordId"));
        const res = await deleteCheckRecord(formData); //http.post("/api/Inventory/DeleteCheckRecord", formData);
        if (res.code === 0) {
          Toast.success("删除成功");
          this.loadRecords();
        } else {
          Toast.fail(res.message || "删除失败");
        }
      } catch (error) {
        Toast.fail("删除失败");
      }
    },
  },
};
</script>

<style scoped>
.records {
  max-width: 512px;
  margin: 0 auto;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.record-list {
  padding: 12px 16px;
}

.record-card {
  background: #fff;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.record-vid {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  word-break: break-all;
}

.record-info {
  font-size: 13px;
  color: #666;
  margin-bottom: 4px;
}

.record-info .label {
  color: #999;
}

.record-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
  margin-top: 8px;
}

.footer-left {
  display: flex;
  gap: 16px;
}

.media-link {
  font-size: 14px;
  cursor: pointer;
}

.video-link {
  color: #007aff;
}

.photo-link {
  color: #07c160;
}

.delete-link {
  color: #ff4d4f;
  font-size: 14px;
  cursor: pointer;
}

.media-link:active {
  opacity: 0.7;
}

.empty-tip {
  text-align: center;
  color: #999;
  padding: 40px;
}

/* 媒体预览样式 */
.media-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;
}

.video-player {
  max-width: 100%;
  max-height: 80vh;
  background: #000;
}

.media-close {
  margin-top: 16px;
  color: #fff;
  font-size: 16px;
  padding: 10px 30px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  cursor: pointer;
}

.photo-viewer {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 85vh;
}

.photo-display {
  max-width: 100%;
  max-height: 75vh;
  object-fit: contain;
  border-radius: 4px;
}

.photo-nav {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 16px;
}

.nav-btn {
  color: #fff;
  font-size: 14px;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  cursor: pointer;
}

.nav-btn:active {
  background: rgba(255, 255, 255, 0.3);
}

.photo-index {
  color: #fff;
  font-size: 14px;
}
</style>
